export const notifyOverLimits = () => (Notify.create({
  title: t("Asset limit reached."),
  body: t("Contact support to upgrade your asset limit."),
  type: "error"
}));
